import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { word } from "@/modules/core/utils/i18n"
import { cn } from "@/modules/lib/utils"
import { useMySpaceNavigate } from "@/modules/navigation/hooks/useMySpaceNavigate"
import { Path } from "@/modules/navigation/routes"
import { TemplateWeekCalendar } from "@/modules/template/components/calendar/templateWeekCalendar"
import { useTemplate } from "@/modules/template/hooks/useTemplate"
import { useTemplateFormSidebar } from "@/modules/template/hooks/useTemplateSidebar"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { ArrowLeftIcon, PencilIcon } from "lucide-react"
import { Suspense } from "react"
import { useParams } from "react-router-dom"

type TemplateWeekPageProps = {
  className?: string
} & React.ComponentProps<"div">

export function TemplateWeekPage({ className, ...props }: TemplateWeekPageProps) {
  const { templateId } = useParams()
  const mySpaceNavigate = useMySpaceNavigate()

  return (
    <div className={cn("flex min-w-245 flex-1 flex-col px-6 py-8", className)} {...props}>
      <div className="flex flex-1 flex-col gap-6">
        <div className="flex flex-col">
          <Button
            variant="underline"
            size="lg"
            onClick={() => {
              mySpaceNavigate(Path.MySpace.Templates)
            }}
            className="w-fit"
          >
            <ArrowLeftIcon size={12} /> {word("template.page.title")}
          </Button>
          <Text fontStyle="HL">{word("template.page.editWeek.title")}</Text>
          {templateId ? <TemplateWeekPageHeader templateId={templateId} /> : null}
        </div>

        {templateId ? (
          <Suspense fallback={<LoadingSpinner />}>
            <TemplateWeekCalendar templateId={templateId} mode="edit" />
          </Suspense>
        ) : null}
      </div>
    </div>
  )
}

type TemplateWeekPageHeaderProps = {
  templateId: string
  className?: string
} & React.ComponentProps<"div">
function TemplateWeekPageHeader({ templateId, className, ...props }: TemplateWeekPageHeaderProps) {
  const { data: template } = useTemplate(templateId)
  const { navigateToTemplateForm } = useTemplateFormSidebar()

  return (
    <div className={cn("flex flex-row items-center gap-2", className)} {...props}>
      <Text fontStyle="BM">{template.name}</Text>
      <Button
        variant="outline"
        size="iconSm"
        onClick={() => {
          navigateToTemplateForm(
            { templateId: templateId },
            {
              replaceAllComponents: true,
            },
          )
        }}
      >
        <PencilIcon />
      </Button>
    </div>
  )
}
